export default __webpack_public_path__ + "static/media/discord.7af7b9f1.svg";